/**
 * FloxOLogo — inline SVG of the FLOX "O" logo (concentric arcs).
 *
 * Source: FLOX-O-logo.svg from the Holly developer pack.
 * Two colour variants: 'colour' (blue+red brand colours) and 'white'.
 */

interface FloxOLogoProps {
  /** Pixel size (width = height) */
  size?: number;
  /** 'colour' shows brand blue/red; 'white' renders all paths white */
  variant?: 'colour' | 'white';
  className?: string;
}

export default function FloxOLogo({
  size = 24,
  variant = 'colour',
  className = '',
}: FloxOLogoProps) {
  const blue = variant === 'white' ? '#FFFFFF' : '#0066cb';
  const red = variant === 'white' ? '#FFFFFF' : '#cb0000';

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 296.54 296.54'
      width={size}
      height={size}
      className={className}
      aria-hidden='true'
    >
      {/* Upper-left arc */}
      <path
        d='M58.08,197.34a11.07,11.07,0,0,0,3.74-13.29A93.93,93.93,0,0,1,82,81.38c17.71-17.71,46.31-29.71,71.26-27.59,29.13,2.47,48.31,15.81,57.41,23.82a11,11,0,0,0,13.7.66h0a11,11,0,0,0,.89-17.17,115.43,115.43,0,0,0-77.48-29.28C84,32.1,32.18,84.39,32.43,148.13a115.41,115.41,0,0,0,9.06,44.53,11,11,0,0,0,16.59,4.68Z'
        fill={blue}
        stroke={variant === 'colour' ? '#fff' : 'none'}
        strokeMiterlimit={10}
        strokeWidth={variant === 'colour' ? 1.54 : 0}
      />
      {/* Lower-right arc */}
      <path
        d='M233,90.56h0a11,11,0,0,0-1.94,13A93.86,93.86,0,0,1,119.35,236.89,11.1,11.1,0,0,0,107.64,240h0a11,11,0,0,0,4.86,17.87,115.62,115.62,0,0,0,36.18,5.64c64-.22,116-52.92,115.43-116.93a115.36,115.36,0,0,0-13.57-53.37A11.06,11.06,0,0,0,233,90.56Z'
        fill={red}
        stroke={variant === 'colour' ? '#fff' : 'none'}
        strokeMiterlimit={10}
        strokeWidth={variant === 'colour' ? 1.54 : 0}
      />
      {/* Centre ring */}
      <path
        d='M148.27,92.24a55.52,55.52,0,1,1-55.51,55.52,55.59,55.59,0,0,1,55.51-55.52m0-22.09a77.61,77.61,0,1,0,77.61,77.61,77.61,77.61,0,0,0-77.61-77.61Z'
        fill={red}
      />
      {/* Outer right arc */}
      <path
        d='M233.39,44.5a11.07,11.07,0,0,0,2,13.53L237,59.6a125.3,125.3,0,0,1,20,151.34,11,11,0,0,0,2.94,14.41h0A11.07,11.07,0,0,0,276.06,222,147.53,147.53,0,0,0,250.55,42a11,11,0,0,0-17.16,2.49Z'
        fill={red}
        stroke={variant === 'colour' ? '#fff' : 'none'}
        strokeMiterlimit={10}
        strokeWidth={variant === 'colour' ? 1.54 : 0}
      />
      {/* Outer top arc */}
      <path
        d='M37.28,70A11.05,11.05,0,0,0,52,67.94q3.61-4.32,7.64-8.34A125.59,125.59,0,0,1,197.08,32.71l.85.37a11,11,0,0,0,13.95-4.61h0a11,11,0,0,0-5.16-15.66A147.61,147.61,0,0,0,34.94,53.87,11,11,0,0,0,37.28,70Z'
        fill={blue}
      />
      {/* Outer bottom-left arc */}
      <path
        d='M176.93,281.17a11.05,11.05,0,0,0-12.24-8.56,125.5,125.5,0,0,1-132-173.15c.86-2,1.76-4,2.72-6a11,11,0,0,0-3.78-13.9h0A11,11,0,0,0,15.51,84,146.84,146.84,0,0,0,.78,146.29C-.29,227.45,65.05,294.64,146.21,295.76a148.37,148.37,0,0,0,21.3-1.24,11.06,11.06,0,0,0,9.42-13.35Z'
        fill={blue}
      />
      {/* Outer bottom-right arc */}
      <path
        d='M252.46,234.78A11,11,0,0,0,238,235.9l-1,1a125.06,125.06,0,0,1-39.87,26.88l-1.18.49a11,11,0,0,0-6.58,12.6h0a11.06,11.06,0,0,0,15,7.82,147.62,147.62,0,0,0,49.41-33.36,11.06,11.06,0,0,0-1.28-16.6Z'
        fill={blue}
      />
    </svg>
  );
}
